<template>
  <div v-if="messages.length > 0">
    <div v-for="message in messages" :key="message">
      <span class="message">{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Warning",
  props: ["messages"],
};
</script>

<style scoped>
.message {
  color: red;
}
</style>
